import React, { useEffect, useId } from "react";
import { createPortal } from "react-dom";
import { getSignPdfFinishThankYouContent } from "./signPdfFinishThankYou";
import "./SignPdfFinishThankYouModal.css";

/**
 * Post-finish thank-you — action-specific message + LazyStudio marketing.
 */
const SignPdfFinishThankYouModal = ({
  action = null,
  open = false,
  onClose = () => {},
  onSignAnother = null,
  onBackToDashboard = null,
}) => {
  const titleId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || !action || typeof document === "undefined") return null;

  const { title, message, icon, marketing } = getSignPdfFinishThankYouContent(action);

  const node = (
    <div className="sp-finish-thanks-root" role="presentation">
      <button
        type="button"
        className="sp-finish-thanks-backdrop"
        aria-label="Close"
        onClick={onClose}
      />
      <div
        className="sp-finish-thanks-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <button
          type="button"
          className="sp-finish-thanks-close"
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>

        <div className="sp-finish-thanks-badge" aria-hidden="true">
          <span className="sp-finish-thanks-badge__icon">{icon}</span>
          <span className="sp-finish-thanks-badge__check">✓</span>
        </div>

        <h2 id={titleId} className="sp-finish-thanks-title">
          {title}
        </h2>
        <p className="sp-finish-thanks-message">{message}</p>

        <div className="sp-finish-thanks-marketing">
          <p className="sp-finish-thanks-marketing__headline">
            {marketing.headline}
          </p>
          <ul className="sp-finish-thanks-marketing__list">
            {marketing.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
          <p className="sp-finish-thanks-marketing__footer">{marketing.footer}</p>
        </div>

        <div className="sp-finish-thanks-actions">
          {onSignAnother ? (
            <button
              type="button"
              className="sp-finish-thanks-btn sp-finish-thanks-btn--secondary"
              onClick={onSignAnother}
            >
              Sign another PDF
            </button>
          ) : null}
          <button
            type="button"
            className="sp-finish-thanks-btn sp-finish-thanks-btn--primary"
            onClick={onClose}
          >
            Got it
          </button>
        </div>
        {typeof onBackToDashboard === "function" ? (
          <button
            type="button"
            className="sp-finish-thanks-dashboard"
            onClick={onBackToDashboard}
          >
            Back to Dashboard
          </button>
        ) : null}
      </div>
    </div>
  );

  return createPortal(node, document.body);
};

export default SignPdfFinishThankYouModal;
